<template>
    <div class="blog-card">
        <img :src="require(`../assets/blogCards/${post.blogCoverPhoto}.jpg`)" alt="" />
        <div class="info">
            <h4>{{ post.blogTitle }}</h4>
            <h6>{{ $t('blogCard.postedOn') }} {{ post.blogDate }}</h6>
            <router-link class="link" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: this.post.blogID } }">
                {{ $t('blogCard.showPostLink') }} <Arrow class="arrow" />
            </router-link>
        </div>
    </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg"

export default {
    name: "blogCard",
    props: ["post"],
    components: {
        Arrow,
    },
};
</script>

<style lang="scss" scoped>

.blog-card {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #fff;
  min-height: 420px;
  transition: 0.5s ease all;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  &:hover {
    transform: rotateZ(-2deg) scale(1.01);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  img {
    display: block;
    border-radius: 8px 8px 0 0;
    z-index: 1;
    width: 100%;
    min-height: 200px;
    object-fit: cover;
  }

  .info {
    display: flex;
    flex-direction: column;
    height: 100%;
    z-index: 3;
    padding: 32px 16px;
    color: #000;
    width: 100%;
    min-width: 0;
    overflow: hidden;

    h4 {
      padding-bottom: 8px;
      font-size: 20px;
      font-weight: 300;
      word-wrap: break-word;
      overflow-wrap: break-word;
      hyphens: auto;

      @media(min-width: 1600px) {
        font-size: 24px;
      }

      @media(min-width: 2000px) {
        font-size: 28px;
      }

      @media(min-width: 2560px) {
        font-size: 32px;
      }
    }

    h6 {
      font-weight: 400;
      font-size: 12px;
      padding-bottom: 16px;

      @media(min-width: 1600px) {
        font-size: 14px;
      }

      @media(min-width: 2000px) {
        font-size: 16px;
      }

      @media(min-width: 2560px) {
        font-size: 18px;
      }
    }

    .link {
      display: inline-flex;
      align-items: center;
      margin-top: auto;
      font-weight: 500;
      padding-top: 20px;
      font-size: 12px;
      padding-bottom: 4px;
      transition: 0.5s ease-in all;

      @media(min-width: 1600px) {
        font-size: 14px;
      }

      @media(min-width: 2000px) {
        font-size: 16px;
      }

      @media(min-width: 2560px) {
        font-size: 18px;
      }

      &:hover {
        color: rgba(48, 48, 48, 0.8);
      }

      .arrow {
        width: 10px;
      }
    }
  }
}
</style>